import { render, staticRenderFns } from "./PCIndustryExperience.vue?vue&type=template&id=e8899e38&scoped=true&"
import script from "./PCIndustryExperience.vue?vue&type=script&lang=js&"
export * from "./PCIndustryExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8899e38",
  null
  
)

export default component.exports